import { styled, Box, BoxProps } from '@mui/material';

import {
  openSidebarWidth,
  closeSidebarWidth,
  masqueradingFooterHeight
} from 'shared/constants/styles';

export const Wrapper = styled(Box, {
  shouldForwardProp: (propName: PropertyKey) => propName !== 'isOpen'
})<BoxProps & { isOpen: boolean }>(({ theme, isOpen }) => ({
  height: `${masqueradingFooterHeight}px`,
  width: `calc(100% - ${isOpen ? openSidebarWidth : closeSidebarWidth}px)`,
  position: 'fixed',
  bottom: 0,
  right: 0,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.25),
  padding: theme.spacing(1, 3),
  background: theme.palette.primary.light,
  color: theme.palette.common.white,

  [theme.breakpoints.down('lg')]: {
    width: '100%'
  }
}));
